const DefaultMetaSettings = {
  title: 'DEWALLET',
  description: 'DEWALLET',
} as const;

export default DefaultMetaSettings;
